(() => {
  'use strict';
  const root = document.querySelector('[data-initial-heart-cuff]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const q = selector => root.querySelector(selector);
  const all = selector => [...root.querySelectorAll(selector)];
  const cfg = JSON.parse(q('[data-initial-heart-cuff-config]').textContent);
  const form = q('#InitialHeartCuffForm');
  const native = q('[data-native-variant]');
  const currency = cfg.currency || 'USD';
  const money = cents => new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const base = (cfg.rootUrl || '/').replace(/\/?$/, '/');
  const cartUrl = cfg.cartUrl || base + 'cart';
  const checkoutUrl = base + 'checkout';
  const route = (destination, code = '') => code ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination) : destination;
  const storageKey = 'tl-initial-heart-cuff-pending:' + cfg.productId;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const finishes = [{ key: 'silver', label: 'Silver-tone' }, { key: 'gold', label: 'Gold color' }];
  const finishOf = value => /^(?:silver(?:[ -]*(?:tone|color|colour))?)$/i.test(String(value).trim()) ? 'silver' : /^(?:gold(?:[ -]*(?:tone|color|colour))?)$/i.test(String(value).trim()) ? 'gold' : '';
  function optionsOf(variant) {
    const options = variant.selectedOptions;
    if (!Array.isArray(options) || options.length !== 2) return null;
    const finish = options.filter(option => finishOf(option.value));
    const letter = options.filter(option => /^[A-Z]$/i.test(String(option.value).trim()));
    if (finish.length !== 1 || letter.length !== 1 || finish[0] === letter[0]) return null;
    return { finish: finishOf(finish[0].value), letter: String(letter[0].value).trim().toUpperCase() };
  }
  const idValid = id => /^[1-9][0-9]*$/.test(String(id)) && Number.isSafeInteger(Number(id));
  const raw = Array.isArray(cfg.variants) ? cfg.variants : [];
  const expected = Array.isArray(cfg.mapping?.variants) ? cfg.mapping.variants : [];
  const mappingValid = cfg.mappingVerified === true && String(cfg.mapping?.productId) === String(cfg.productId) && expected.length === raw.length && raw.length > 0 && new Set(raw.map(v => String(v.id))).size === raw.length && new Set(expected.map(v => String(v.id))).size === expected.length && raw.every(variant => {
    const options = optionsOf(variant);
    return options && expected.filter(item => String(item.id) === String(variant.id) && item.sku === variant.sku && item.finish === options.finish && item.letter === options.letter).length === 1;
  });
  const variants = (mappingValid ? raw : []).flatMap(variant => {
    const options = optionsOf(variant);
    const mapped = expected.find(item => String(item.id) === String(variant.id));
    return options && mapped?.finish === options.finish && mapped?.letter === options.letter && idValid(variant.id) && raw.filter(item => String(item.id) === String(variant.id)).length === 1 && Number.isSafeInteger(variant.price) && variant.price >= 0
      ? [{ ...variant, ...options, id: String(variant.id) }] : [];
  });
  const byId = id => variants.find(variant => variant.id === String(id));
  // Unknown stock is not unlimited stock. Explicit native untracked/continue policies are respected.
  function capacity(variant) {
    if (!variant || variant.available !== true) return 0;
    if (variant.inventoryManagement === null || variant.inventoryManagement === '') return Infinity;
    if (typeof variant.inventoryManagement !== 'string') return 0;
    if (variant.inventoryPolicy === 'continue') return Infinity;
    if (variant.inventoryPolicy !== 'deny' || !Number.isSafeInteger(variant.inventoryQuantity)) return 0;
    return Math.max(0, variant.inventoryQuantity);
  }
  const variantFor = state => {
    const matches = variants.filter(variant => variant.finish === state.finish && variant.letter === state.letter);
    return matches.length === 1 ? matches[0] : null;
  };
  const choice = variant => variant ? { finish: variant.finish, letter: variant.letter } : { finish: '', letter: '' };
  const preferred = variants.find(variant => variant.finish === 'silver' && variant.letter === 'M' && capacity(variant) > 0 && variantFor(variant));
  const first = preferred || variants.find(variant => capacity(variant) > 0 && variantFor(variant));
  const explicitId = new URL(location.href).searchParams.get('variant');
  const explicit = byId(explicitId);
  const states = [choice(explicitId ? explicit : first), choice(first)];
  let busy = false;
  let operationActive = false;
  let navigating = false;
  let pending = null;
  let recoveryLock = false;
  let bagCode = '';
  let stockError = '';
  let continuationTimer;
  let loadingOpener;
  let bagOpener;
  const quantity = () => Number(q('[name="initial-heart-cuff-offer"]:checked').value);
  const chosen = (count = quantity()) => states.slice(0, count).map(variantFor);
  const discountValid = () => cfg.duoEnabled === true && cfg.duoCodeConfirmed === true && currency === 'USD' && /^[A-Za-z0-9_-]{1,64}$/.test(cfg.duoCode || '') && Number.isSafeInteger(cfg.duoDiscountPerItemCents) && cfg.duoDiscountPerItemCents > 0;
  const discountReady = selection => discountValid() && selection.length === 2 && selection.every(variant => variant && variant.price > cfg.duoDiscountPerItemCents);
  function savePending(value) {
    pending = value;
    try { if (value) sessionStorage.setItem(storageKey, JSON.stringify(value)); else sessionStorage.removeItem(storageKey); }
    catch { /* The in-memory reference protects this page even when storage is denied. */ }
  }
  let storedIntent = '';
  try {
    storedIntent = sessionStorage.getItem(storageKey) || '';
    const saved = JSON.parse(storedIntent || 'null');
    if (saved && saved.version === 1 && /^IHC-[a-z0-9-]{8,100}$/i.test(saved.reference) && ['sending', 'saved'].includes(saved.status) && Array.isArray(saved.items) && [1, 2].includes(saved.items.length) && saved.items.every((item, index) => idValid(item.id) && item.quantity === 1 && item.slot === index + 1)) pending = saved;
    else if (storedIntent) recoveryLock = true;
    if (discountValid() && sessionStorage.getItem(storageKey + ':offer') === cfg.duoCode) bagCode = cfg.duoCode;
  } catch { recoveryLock = Boolean(storedIntent); }
  if (!mappingValid) { recoveryLock = true; pending = null; }
  // Acknowledged saves can start a new selection; uncertain requests can only be read back.
  if (pending?.status === 'saved') savePending(null);
  q('[name="initial-heart-cuff-offer"][value="1"]').checked = true;
  if (pending) {
    pending.items.forEach((item, index) => { states[index] = choice(byId(item.id)); });
    q('[name="initial-heart-cuff-offer"][value="' + pending.items.length + '"]').checked = true;
  }
  root.classList.add('ihc-enhanced');
  const slots = all('[data-slot]');
  const finishPhotos = key => q('[data-source="' + key + '"]')?.dataset.full || '';
  slots.forEach((slot, index) => {
    const finishGroup = slot.querySelector('[data-finish-buttons]');
    finishes.forEach(finish => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.finish = finish.key; button.setAttribute('aria-pressed', 'false');
      const image = document.createElement('img'); image.src = finishPhotos(finish.key); image.alt = ''; image.width = 46; image.height = 46;
      const label = document.createElement('span'); label.textContent = finish.label;
      button.append(image, label); finishGroup.append(button);
      button.addEventListener('click', () => {
        if (busy || pending || recoveryLock) return;
        states[index].finish = finish.key;
        updateSelection(index);
      });
    });
    const letters = slot.querySelector('[data-letter-buttons]');
    for (const letter of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.letter = letter; button.textContent = letter;
      button.setAttribute('aria-label', 'Bracelet ' + (index + 1) + ': initial ' + letter);
      button.setAttribute('aria-pressed', 'false'); letters.append(button);
      button.addEventListener('click', () => {
        if (busy || pending || recoveryLock) return;
        states[index].letter = letter;
        updateSelection(index);
      });
    }
  });
  function grouped(selection) {
    const quantities = new Map();
    selection.filter(Boolean).forEach(variant => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
    return [...quantities].map(([id, count]) => ({ id, count }));
  }
  function selectionError(selection, cart = null) {
    if (recoveryLock) return 'An earlier selection could not be read safely. Open your native cart to review it before ordering.';
    if (selection.some(variant => !variant)) return 'Choose an available letter and finish for each bracelet. We will not substitute another variant.';
    if (selection.length === 2 && cfg.duoEnabled !== true) return 'Please choose the single-bracelet option.';
    for (const item of grouped(selection)) {
      const already = (cart?.items || []).filter(line => String(line.variant_id || line.id) === item.id).reduce((sum, line) => sum + line.quantity, 0);
      if (already + item.count > capacity(byId(item.id))) return 'Not enough confirmed stock for ' + byId(item.id).letter + ' / ' + finishes.find(finish => finish.key === byId(item.id).finish).label + (already ? ', including the bracelets already in your cart.' : '. Choose another letter or finish.');
    }
    return '';
  }
  function pricing(selection) {
    if (selection.some(variant => !variant)) return null;
    const amounts = selection.map(variant => variant.price - (discountReady(selection) ? cfg.duoDiscountPerItemCents : 0));
    return { amounts, total: amounts.reduce((sum, price) => sum + price, 0), unit: amounts.every(price => price === amounts[0]) ? money(amounts[0]) : money(Math.min(...amounts)) + ' - ' + money(Math.max(...amounts)) };
  }
  function sync() {
    const count = quantity();
    const selection = chosen();
    const current = pricing(selection);
    stockError = selectionError(selection);
    native.value = selection[0]?.id || '';
    slots.forEach((slot, index) => {
      slot.hidden = index >= count;
      const state = states[index];
      const selected = variantFor(state);
      slot.querySelector('[data-slot-heading]').textContent = index === 0 && count === 1 ? 'Your bracelet' : 'Bracelet ' + (index + 1);
      slot.querySelector('[data-chosen-letter]').textContent = state.letter || '?';
      slot.querySelector('[data-picked]').textContent = selected ? selected.letter + ' / ' + finishes.find(finish => finish.key === selected.finish).label : 'Choose your letter + finish';
      slot.querySelector('[data-slot-price]').textContent = selected ? money(selected.price - (discountReady(chosen(2)) && count === 2 ? cfg.duoDiscountPerItemCents : 0)) + ' / bracelet' : '';
      slot.querySelectorAll('[data-finish]').forEach(button => {
        const candidate = variantFor({ ...state, finish: button.dataset.finish });
        button.setAttribute('aria-pressed', String(state.finish === button.dataset.finish));
        // Keep a finish selectable when another letter is stocked in it, but never silently change the letter.
        const available = variants.some(variant => variant.finish === button.dataset.finish && capacity(variant) > 0 && variantFor(variant));
        button.disabled = index >= count || busy || Boolean(pending) || recoveryLock || !available;
        button.title = candidate && capacity(candidate) > 0 ? '' : 'Choose an available letter in this finish';
        const image = candidate?.image;
        button.querySelector('img').src = image || finishPhotos(button.dataset.finish);
      });
      slot.querySelectorAll('[data-letter]').forEach(button => {
        const candidate = variantFor({ ...state, letter: button.dataset.letter });
        const available = capacity(candidate) > 0;
        button.disabled = index >= count || busy || Boolean(pending) || recoveryLock || !available;
        button.setAttribute('aria-pressed', String(state.letter === button.dataset.letter));
        button.setAttribute('aria-label', 'Bracelet ' + (index + 1) + ': initial ' + button.dataset.letter + (available ? '' : ', unavailable in this finish'));
      });
    });
    for (const offerCount of [1, 2]) {
      const price = pricing(chosen(offerCount));
      q('[data-offer-unit="' + offerCount + '"]').textContent = price ? price.unit + ' / bracelet' : 'Choose letters';
      q('[data-offer-total="' + offerCount + '"]').textContent = price ? money(price.total) + ' total' : 'Choose letter + finish';
    }
    q('[data-unit-price]').textContent = current ? current.unit : '--';
    q('[data-unit-caption]').textContent = count === 2 && discountReady(selection) ? 'per bracelet with duo offer' : 'per bracelet';
    q('[data-duo-saving]').hidden = !discountReady(chosen(2));
    q('[data-duo-saving]').textContent = discountReady(chosen(2)) ? 'Save ' + money(cfg.duoDiscountPerItemCents * 2) + ' together' : '';
    q('[data-offer-note]').textContent = discountReady(chosen(2)) ? cfg.duoCode + ' takes ' + money(cfg.duoDiscountPerItemCents) + ' off each eligible bracelet when you choose two. Other discounts may not combine. Checkout confirms eligibility and tax.' : 'Each bracelet uses its current native price. Choose two to select each letter and finish separately. Checkout confirms any applicable offers and tax.';
    q('[data-selection-label]').textContent = count === 1 ? '1 bracelet' : '2 individual bracelets';
    q('[data-selection-contents]').textContent = selection.map((variant, index) => variant ? (index + 1) + ': ' + variant.letter + ' / ' + finishes.find(finish => finish.key === variant.finish).label : (index + 1) + ': choose a letter + finish').join(' | ');
    q('[data-selection-total]').textContent = current ? money(current.total) : '--';
    q('[data-sticky-price]').textContent = current ? current.unit + ' each / ' + money(current.total) + ' total' : 'Choose letter + finish';
    q('[data-stock-error]').hidden = !stockError || Boolean(pending);
    q('[data-stock-error]').textContent = stockError;
    q('[data-add-label]').textContent = pending ? 'Check saved selection' : 'Add ' + (count === 1 ? 'bracelet' : 'two bracelets') + ' to bag';
    q('[data-buy-label]').textContent = pending ? 'Check bag & continue' : 'Buy now' + (current ? ' - ' + money(current.total) : '');
    all('[data-buy],[data-add]').forEach(button => { button.disabled = busy || (!pending && Boolean(stockError)); });
    q('[data-sticky-buy]').disabled = busy || recoveryLock;
    q('[data-sticky-label]').textContent = stockError && !pending ? 'Choose options' : 'Buy now';
    all('[name="initial-heart-cuff-offer"]').forEach(input => { input.disabled = busy || Boolean(pending) || recoveryLock || (input.value === '2' && (cfg.duoEnabled !== true || variants.reduce((sum, variant) => sum + capacity(variant), 0) < 2)); });
    form.setAttribute('aria-busy', String(busy));
  }
  function feedback(text, withCart = false, code = bagCode) {
    q('[data-feedback]').replaceChildren(document.createTextNode(text));
    if (withCart) {
      const link = document.createElement('a'); link.href = route(cartUrl, code); link.textContent = ' View or edit your cart.'; q('[data-feedback]').append(link);
    }
  }
  function setBusy(value, checkout = false) {
    busy = value;
    const dialog = q('[data-loading]');
    if (value && checkout) {
      if (!dialog.open) { loadingOpener = document.activeElement; q('[data-loading-label]').textContent = 'Saving your chosen letters and opening secure checkout...'; dialog.showModal(); }
    } else {
      clearTimeout(continuationTimer); q('[data-checkout-continue]').hidden = true;
      if (dialog.open) { dialog.close(); loadingOpener?.focus?.({ preventScroll: true }); }
    }
    sync();
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { ...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json', ...(options.headers || {}) } });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(typeof data.description === 'string' ? data.description : 'Your cart needs a check. No extra request will be sent until it is confirmed.');
        error.definiteRejection = [400, 401, 403, 404, 422].includes(response.status);
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  async function readCart() {
    const cart = await request(base + 'cart.js');
    if (!Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || cart.items.some(line => !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !idValid(line.variant_id || line.id)) || cart.items.reduce((sum, line) => sum + line.quantity, 0) !== cart.item_count) throw new Error('Your cart could not be confirmed. Open the native cart to review it.');
    return cart;
  }
  function recovery(cart) {
    const lines = (cart.items || []).filter(line => line.properties?.['_TENLOVE reference'] === pending.reference);
    if (!lines.length) return 'none';
    return lines.length === pending.items.length && pending.items.every(item => lines.filter(line => String(line.variant_id || line.id) === String(item.id) && String(line.properties?.['_TENLOVE slot']) === String(item.slot) && line.quantity === 1).length === 1) ? 'complete' : 'partial';
  }
  function renderBag(cart) {
    q('[data-bag-count]').textContent = cart.item_count;
    q('[data-bag-status]').textContent = cart.item_count ? cart.item_count + ' items in your bag.' : 'Your bag is empty.';
    q('[data-bag-lines]').replaceChildren();
    cart.items.forEach(line => {
      const item = document.createElement('li'); const title = document.createElement('b'); const detail = document.createElement('span'); const price = document.createElement('strong');
      title.textContent = line.product_title || line.title || 'Cart item';
      detail.textContent = [line.variant_title === 'Default Title' ? '' : line.variant_title, 'Quantity ' + line.quantity].filter(Boolean).join(' / ');
      price.textContent = Number.isSafeInteger(line.final_line_price) ? money(line.final_line_price) : '';
      item.append(title, detail, price); q('[data-bag-lines]').append(item);
    });
    q('[data-bag-subtotal]').textContent = Number.isSafeInteger(cart.total_price) ? money(cart.total_price) : 'Confirmed at checkout';
    q('[data-bag-offer]').textContent = bagCode ? bagCode + ' is carried to checkout for eligible bracelets. This subtotal may not include the offer yet. Checkout confirms discounts, shipping and tax.' : 'Checkout confirms discounts, shipping and tax.';
    q('[data-bag-checkout]').href = route(checkoutUrl, bagCode); q('[data-bag-checkout]').hidden = !cart.item_count;
    q('[data-native-bag]').href = route(cartUrl, bagCode);
  }
  function openBag() { bagOpener = document.activeElement; if (!q('[data-bag-dialog]').open) q('[data-bag-dialog]').showModal(); }
  function closeBag() { q('[data-bag-dialog]').close(); bagOpener?.focus?.({ preventScroll: true }); }
  function navigateToCheckout() {
    const destination = route(checkoutUrl, bagCode);
    q('[data-loading-label]').textContent = 'Your selection is saved. Opening secure checkout...';
    q('[data-checkout-continue]').href = destination;
    continuationTimer = setTimeout(() => { q('[data-checkout-continue]').hidden = false; }, 10000);
    navigating = true; location.assign(destination);
  }
  async function finishSave(checkout, cart = null) {
    const count = pending.items.length;
    bagCode = count === 2 && discountReady(pending.items.map(item => byId(item.id))) ? cfg.duoCode : '';
    try { if (bagCode) sessionStorage.setItem(storageKey + ':offer', bagCode); else sessionStorage.removeItem(storageKey + ':offer'); } catch {}
    if (cart) q('[data-bag-count]').textContent = cart.item_count;
    if (checkout) {
      savePending({ ...pending, status: 'saved' }); navigateToCheckout(); return;
    }
    savePending(null);
    feedback('Added ' + count + (count === 1 ? ' bracelet' : ' bracelets') + ' to your bag.', true);
    try { renderBag(cart || await readCart()); openBag(); }
    catch { feedback('Your bracelets were saved. Open your native cart to review them and continue.', true); }
  }
  async function add(checkout) {
    if (busy || (!pending && stockError)) return;
    operationActive = true;
    setBusy(true, checkout);
    feedback(checkout ? 'Saving your selection and opening checkout...' : 'Adding your chosen letters to your bag...');
    let attemptedWrite = false;
    try {
      const cart = await readCart();
      const state = pending ? recovery(cart) : 'none';
      if (state === 'partial') throw new Error('Only part of the saved selection is confirmed in your cart. Please review it; we will not add the missing part or repeat the request.');
      if (state === 'complete') { await finishSave(checkout, cart); return; }
      if (pending) throw new Error('The earlier request is still uncertain. Please review your cart; we will only check its reference, never send it again.');
      const error = selectionError(chosen(), cart);
      if (error) throw new Error(error);
      const items = chosen().map((variant, index) => ({ id: variant.id, quantity: 1, slot: index + 1 }));
      savePending({ version: 1, reference: 'IHC-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)), items, status: 'sending' });
      sync();
      const body = { items: items.map(item => {
        const variant = byId(item.id);
        return { id: item.id, quantity: 1, properties: { Contents: 'One initial heart cable cuff', Initial: variant.letter, Finish: finishes.find(finish => finish.key === variant.finish).label, '_TENLOVE reference': pending.reference, '_TENLOVE slot': String(item.slot) } };
      }) };
      attemptedWrite = true;
      const result = await request(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (recovery({ items: Array.isArray(result.items) ? result.items : [result] }) !== 'complete') throw new Error('Your cart response needs a reference check.');
      q('[data-bag-count]').textContent = cart.item_count + items.length;
      await finishSave(checkout);
    } catch (error) {
      navigating = false;
      let message = error.name === 'AbortError' ? 'That request took longer than expected. We will check its reference without adding a second copy.' : error.message || 'Please review your cart before trying again.';
      if (attemptedWrite && pending?.status === 'sending') {
        try {
          const cart = await readCart();
          const state = recovery(cart);
          if (state === 'complete') { await finishSave(checkout, cart); return; }
          if (state === 'partial') message = 'Only part of your saved selection is in the cart. Review it in the native cart; no extra bracelets will be added automatically.';
          else if (error.definiteRejection) savePending(null);
          // Absence after a timeout/5xx is not proof that the POST cannot commit later.
        } catch { /* Keep the uncertain intent locked until a later read can reconcile it. */ }
      }
      feedback(message, true, pending?.items.length === 2 && discountValid() ? cfg.duoCode : bagCode);
    } finally { operationActive = false; if (!navigating) setBusy(false); }
  }
  function updateSelection(index) {
    if (index === 0) {
      const url = new URL(location.href); const variant = variantFor(states[0]);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      history.replaceState(history.state, '', url);
    }
    feedback(''); sync(); showVariant(variantFor(states[index]));
  }
  form.addEventListener('submit', event => { event.preventDefault(); add(Boolean(event.submitter?.hasAttribute('data-buy'))); });
  all('[name="initial-heart-cuff-offer"]').forEach(input => input.addEventListener('change', () => {
    if (!busy && !pending && !recoveryLock) { sync(); showVariant(chosen()[0]); }
  }));
  native.addEventListener('change', () => { if (!busy && !pending && !recoveryLock) { states[0] = choice(byId(native.value)); updateSelection(0); } });
  q('[data-sticky-buy]').addEventListener('click', () => {
    if (stockError && !pending) { q('#InitialHeartCuffPurchase').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' }); slots.find(slot => !slot.hidden)?.querySelector('button:not(:disabled)')?.focus({ preventScroll: true }); }
    else add(true);
  });
  q('[data-open-bag]').addEventListener('click', async event => {
    event.preventDefault(); if (busy) return;
    openBag(); q('[data-bag-status]').textContent = 'Loading your bag...'; q('[data-bag-checkout]').hidden = true; q('[data-bag-lines]').replaceChildren(); q('[data-bag-subtotal]').textContent = ''; q('[data-bag-offer]').textContent = '';
    try { renderBag(await readCart()); } catch { q('[data-bag-status]').textContent = 'Use View or edit your cart below to continue in the native cart.'; }
  });
  q('[data-close-bag]').addEventListener('click', closeBag); q('[data-continue]').addEventListener('click', closeBag);
  q('[data-bag-dialog]').addEventListener('click', event => { if (event.target === q('[data-bag-dialog]')) closeBag(); });
  q('[data-bag-checkout]').addEventListener('click', event => { event.preventDefault(); closeBag(); setBusy(true, true); navigateToCheckout(); });
  q('[data-loading]').addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  const photo = q('[data-main-photo]');
  const lightbox = q('[data-lightbox]');
  let photoIndex = 0;
  const thumbs = () => all('[data-thumb]').filter(thumb => !thumb.hidden);
  function selectPhoto(index) {
    const buttons = thumbs(); if (!buttons.length) return;
    photoIndex = (index + buttons.length) % buttons.length;
    const button = buttons[photoIndex];
    photo.src = button.dataset.full; photo.srcset = button.dataset.small + ' 600w, ' + button.dataset.full + ' 1200w'; photo.alt = button.dataset.alt;
    q('[data-photo-index]').textContent = String(photoIndex + 1).padStart(2, '0') + ' / ' + String(buttons.length).padStart(2, '0');
    all('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    if (lightbox.open) { lightbox.querySelector('img').src = photo.src; lightbox.querySelector('img').alt = photo.alt; }
  }
  function showVariant(variant) {
    if (!variant) return;
    if (variant.image) {
      const button = q('[data-native-thumb]');
      button.hidden = false; button.dataset.full = variant.image; button.dataset.small = variant.smallImage || variant.image;
      button.dataset.alt = 'Supplier finish reference; example A pictured. Selected initial: ' + variant.letter + ' / ' + finishes.find(finish => finish.key === variant.finish).label;
      button.querySelector('img').src = button.dataset.small;
      button.querySelector('span').textContent = variant.letter + ' / ' + finishes.find(finish => finish.key === variant.finish).label;
      selectPhoto(thumbs().indexOf(button));
    } else {
      q('[data-native-thumb]').hidden = true;
      selectPhoto(thumbs().indexOf(q('[data-source="' + variant.finish + '"]')));
    }
  }
  all('[data-thumb]').forEach(button => button.addEventListener('click', () => selectPhoto(thumbs().indexOf(button))));
  q('[data-enlarge]').addEventListener('click', () => { lightbox.querySelector('img').src = photo.src; lightbox.querySelector('img').alt = photo.alt; lightbox.showModal(); });
  q('[data-close-photo]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  lightbox.addEventListener('close', () => q('[data-enlarge]').focus({ preventScroll: true }));
  q('[data-inspect-source]').addEventListener('click', () => { selectPhoto(thumbs().indexOf(q('[data-source="' + (variantFor(states[0])?.finish || 'silver') + '"]'))); q('[data-enlarge]').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' }); });
  q('.ihc-thumbs').addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault(); selectPhoto(event.key === 'Home' ? 0 : event.key === 'End' ? thumbs().length - 1 : photoIndex + (event.key === 'ArrowRight' ? 1 : -1)); thumbs()[photoIndex].focus();
  });
  lightbox.addEventListener('keydown', event => { if (['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); selectPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
  if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0; }).observe(form);
  window.addEventListener('pageshow', () => {
    if (operationActive && !navigating) return;
    navigating = false; if (pending?.status === 'saved') savePending(null); setBusy(false);
  });
  if (pending) feedback('An earlier selection needs a reference check. We will not send it again.', true);
  sync();
  if (chosen()[0]) showVariant(chosen()[0]);
})();
